import React from "react";
import { Link } from "react-router-dom";
const Section2 = () => {
  return (
    <div className="container-fluid"> 
    <div style={{ marginTop: "150px" }}>
      <div className="card-group">
        <div className="card">
          <div className="img-hover-zoom">
            <img
              className="card-img-top"
              src="https://i.ibb.co/dBsT6H6/2-1.jpg"
              alt="Card cap"
              style={{ height: "400px" }}
            />
          </div>

          <div
            className="card-body"
            style={{
              height: "400px",
              textAlign: "center",
              paddingTop: "150px",
            }}
          >
            <h5 className="card-title">DELICIOUS CAKES</h5>
            <p className="card-text">
              Limited edition. Eco-friendly. Not just for working out
            </p>
           <Link to="/shop"> <span className="mx-auto" style={{textDecoration:"none",width:"120px"}}>SHOP NOW</span></Link>
          </div>
        </div>
        <div className="card">
          <div
            className="card-body"
            style={{
              height: "400px",
              textAlign: "center",
              paddingTop: "150px",
            }}
          >
            <h5 className="card-title">CARROT CAKE</h5>
            <p className="card-text">
              Limited edition. Eco-friendly. Not just for working out
            </p>
            <Link to="/shop"> <span className="mx-auto" style={{textDecoration:"none",width:"120px"}}>SHOP NOW</span></Link>
          </div>
          <div className="img-hover-zoom">
            <img
              className="card-img-top"
              src="https://i.ibb.co/rHwjX3p/2-3.jpg"
              alt="Card  cap"
              style={{ height: "400px" }}
            />
          </div>
        </div>
        <div className="card">
          <div className="img-hover-zoom">
            <img
              className="card-img-top"
              src="https://i.ibb.co/XjStyBP/2-2.jpg"
              alt="Card  cap"
              style={{ height: "400px" }}
            />
          </div>
          <div
            className="card-body"
            style={{
              height: "400px",
              textAlign: "center",
              paddingTop: "150px",
            }}
          >
            <h5 className="card-title">100% CHOCOLATE</h5>
            <p className="card-text">
              Limited edition. Eco-friendly. Not just for working out
            </p>
            <Link to="/shop"> <span className="mx-auto" style={{textDecoration:"none",width:"120px"}}>SHOP NOW</span></Link>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Section2;
